/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Hls_Manifest_LabelInputs */

const en_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS Manifest URL`)
};

const fr_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL du manifeste HLS`)
};

const de_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS-Manifest-URL`)
};

const it_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL manifesto HLS`)
};

const ru_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL манифеста HLS`)
};

const es_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del manifiesto HLS`)
};

const zh_cn2_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS清单URL`)
};

const ja_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLSマニフェストURL`)
};

const hi_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HLS मैनिफेस्ट URL`)
};

const pt_pt2_new_project_hls_manifest_label = /** @type {(inputs: New_Project_Hls_Manifest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do manifesto HLS`)
};

/**
* | output |
* | --- |
* | "HLS Manifest URL" |
*
* @param {New_Project_Hls_Manifest_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_hls_manifest_label = /** @type {((inputs?: New_Project_Hls_Manifest_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Hls_Manifest_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_hls_manifest_label(inputs)
	if (locale === "de") return de_new_project_hls_manifest_label(inputs)
	if (locale === "it") return it_new_project_hls_manifest_label(inputs)
	if (locale === "ru") return ru_new_project_hls_manifest_label(inputs)
	if (locale === "es") return es_new_project_hls_manifest_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_hls_manifest_label(inputs)
	if (locale === "ja") return ja_new_project_hls_manifest_label(inputs)
	if (locale === "hi") return hi_new_project_hls_manifest_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_hls_manifest_label(inputs)
	return en_new_project_hls_manifest_label(inputs)
});